'use client';
import styled from 'styled-components';
import { getFlexWidthStyle } from '../../mixins/getFlexWidthStyle.js';
import { getVisibilityStyle } from '../../mixins/getVisibilityStyle.js';
import { getColGutterStyle } from './mixins/getGutterStyle.js';

const Col = styled.div.attrs(({
  width = 'stretch'
}) => ({
  width
})).withConfig({
  shouldForwardProp: (prop, defaultValidatorFn) => !['width'].includes(prop) && defaultValidatorFn(prop)
}).withConfig({
  componentId: "sc-2mqb3p-0"
})(["list-style:none;", ";", ";", ";"], ({
  gutter
}) => typeof gutter !== 'undefined' && getColGutterStyle(gutter), ({
  width
}) => getFlexWidthStyle(width), ({
  visible
}) => typeof visible !== 'undefined' && getVisibilityStyle(visible));

export { Col };
//# sourceMappingURL=Col.js.map
